import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import Icon from "@/icons";
import { SettingsTeamOverview } from "./TSettings/Overview";
import { User } from "types";
import { DeleteTeam } from "./DeleteTeam";
import { SettingsTeamDiscovery } from "./TSettings/Discovery";
import { SettingsTeamRoles } from "./TSettings/Roles";
import permissions from "@/permissions";
import { SettingsTeamEmojis } from "./TSettings/Emoji";
import { SettingsTeamTemplate } from "./TSettings/Templates";

export const TeamSettings = ({ children, team, setTeamData, me, userpermissions, setDropdown }: { children: React.ReactNode, team: any, setTeamData: any, me: User, userpermissions: string, setDropdown: any }) => {
    const [selectedOption, setSelectedOption] = useState('overview');
    const [isOpened, setIsOpened] = useState(false);
    const isActive = (option: string) => {
        return option === selectedOption ? 'bg-brand-profile'
            : 'bg-brand-dark';
    }

    return (
        <Dialog open={isOpened} onOpenChange={
            (isOpen) => {
                setIsOpened(isOpen);
                setDropdown(isOpen);
            }   
        }>
            <DialogTrigger asChild>
                {children}
            </DialogTrigger>
            <DialogContent className="min-w-full rounded-none bg-brand-back border-none sm:rounded-none sm:h-screen sm:max-w-4xl flex flex-col sm:flex-row p-0 overflow-auto">
                <div className="px-4 py-6 bg-brand-dark w-full sm:w-1/4 sm:px-8 overflow-auto" style={{ scrollbarWidth: "none" }}>
                    <div className="flex flex-col items-start w-full h-full sm:h-screen p-4 font-semibold overflow-auto">
                        <div className="flex flex-col items-center justify-center text-gray-200 rounded-full">
                            <span>Team Settings</span>
                        </div>
                        <div className="w-full mt-4 items-start justify-between space-y-2 flex flex-col">
                            <button
                                onClick={() => {
                                    setSelectedOption('overview');
                                }}
                                className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('overview')}`}
                            >
                                Overview
                            </button>
                            {Boolean(BigInt(userpermissions ?? '0') & permissions.get("MANAGE_TEAM" as string)!) && (
                            <button
                                onClick={() => {
                                    setSelectedOption('discovery');
                                }}
                                className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('discovery')}`}
                            >
                                Discovery
                            </button>
                            )}
                            {Boolean(BigInt(userpermissions ?? '0') & permissions.get("MANAGE_TEAM" as string)!) && (
                            <button
                                onClick={() => {
                                    setSelectedOption('template');
                                }}
                                className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('template')}`}
                            >
                                Template
                            </button>
                            )}
                            {Boolean(BigInt(userpermissions ?? '0') & permissions.get("MANAGE_TEAM" as string)!) && (
                            <button
                                onClick={() => {
                                    setSelectedOption('emoji');
                                }}
                                className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('emoji')}`}
                            >
                                Emoji
                            </button>
                            )}
                            {Boolean(BigInt(userpermissions ?? '0') & permissions.get("MANAGE_ROLES" as string)!) && (
                            <button
                                onClick={() => {
                                    setSelectedOption('roles');
                                }}
                                className={`text-gray-200 flex gap-2 items-center hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-white w-full ${isActive('roles')}`}
                            >
                                Roles
                            </button>
                            )}
                            <>
                                {me.id === team?.createdBy && (
                                    <><hr className="border-gray-600 w-full my-2" />
                                        <div className="flex items-center min-w-full">
                                            <DeleteTeam team={team}>
                                                <span
                                                    className={`text-red-400 flex hover:bg-brand-darkest text-left px-2 rounded-lg py-2 hover:text-red-500 transition-all w-full`}
                                                >
                                                    Delete Team
                                                </span>
                                            </DeleteTeam>
                                        </div>
                                    </>
                                )}
                            </>
                        </div>
                    </div>
                </div>
                <div className="w-full sm:w-3/4 p-4 py-12 sm:overflow-hidden max-h-96 sm:max-h-full overflow-auto">
                    <DialogHeader>
                        <DialogTitle>
                            {selectedOption === 'overview' && (
                                <div className="flex items-center gap-4">
                                    <Icon name="settings" size="24" color="white" />
                                    <h1 className="text-gray-200 font-semibold text-lg">Overview</h1>
                                </div>
                            ) || selectedOption === 'emoji' && (
                                <div className="flex items-center gap-4">
                                    <Icon name="settings" size="24" color="white" />
                                    <h1 className="text-gray-200 font-semibold text-lg">Emoji</h1>
                                </div>
                            )}
                        </DialogTitle>
                        <DialogDescription>
                        </DialogDescription>
                    </DialogHeader>
                    <div className="w-full">
                        {selectedOption === 'overview' && (
                            <SettingsTeamOverview setTeamData={setTeamData} me={userpermissions} />
                        ) || selectedOption === 'discovery' && (
                            <SettingsTeamDiscovery/>
                        ) || selectedOption === 'roles' && (
                            <SettingsTeamRoles me={userpermissions} team={team} user={me} />
                        ) || selectedOption === "emoji" && (
                            <SettingsTeamEmojis me={userpermissions} team={team} user={me} />
                        ) || selectedOption === 'template' && (
                            <SettingsTeamTemplate team={team} />
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
